import { createContext, useContext } from "react";

const Context = createContext({
	localeId: "en-us",
	pathPrefix: "",
});

export const LocaleContextProvider = ({ children, value }) => {
	return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useLocale = () => {
	const context = useContext(Context);

	if (!context) {
		throw new Error("useLocale must be used within a LocaleContextProvider");
	}

	return context;
};
